import { FacebookIcon } from '@/common/icons/FacebookIcon';
import { InstagramIcon } from '@/common/icons/InstagramIcon';
import { LinkedinIcon } from '@/common/icons/LinkedinIcon';
import { MailIcon } from '@/common/icons/MailIcon';
import { MapPinIcon } from '@/common/icons/MapPinIcon';
import { PhoneIcon } from '@/common/icons/PhoneIcon';
import { TelegramIcon } from '@/common/icons/TelegramIcon';
import { YoutubeIcon } from '@/common/icons/YoutubeIcon';
import { NavLink, ContactItem, SocialLink } from './types';

export const NAV_LINKS: NavLink[] = [
  { label: 'Yer maydoni', href: '/' },
  { label: 'Monitoring', href: '/monitoring' },
  { label: 'Hosil qabuli', href: '/harvest' },
  { label: 'Birja', href: '/birja' },
  { label: 'Bank', href: '/bank' },
  { label: 'Moddiy resurs nazorati', href: '/material_control' },
];

export const SOCIAL_LINKS: SocialLink[] = [
  {
    icon: <LinkedinIcon />,
    label: 'LinkedIn',
    href: 'http://t.ly/pjAw',
  },
  {
    icon: <TelegramIcon />,
    label: 'Telegram',
    href: 'http://t.me/digital_agrouz',
  },
  {
    icon: <YoutubeIcon />,
    label: 'YouTube',
    href: 'https://t.ly/slgNI',
  },
  {
    icon: <InstagramIcon />,
    label: 'Instagram',
    href: 'https://t.ly/7imL',
  },
  {
    icon: <FacebookIcon />,
    label: 'Facebook',
    href: 'https://t.ly/OQHZ',
  },
];

export const CONTACT_ITEMS: ContactItem[] = [
  {
    icon: <MailIcon />,
    content: <a href="mailto:digitalization@agro.uz">digitalization@agro.uz</a>,
  },
  {
    icon: <PhoneIcon />,
    content: <span>+998 (71) 206-70-07</span>,
  },
  {
    icon: <MapPinIcon />,
    content: (
      <span>
        Toshkent viloyati, Qibray tumani, Universitet ko&apos;chasi, 2
      </span>
    ),
  },
];
